import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30173e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component preview" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = { class: "loading-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "로딩 여부", -1))
const _hoisted_5 = { class: "radio__box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio__btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "radio__active" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Yes", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio__btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "radio__active" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "info-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["radio__option", {'active': _ctx.loading}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLoading(1)))
          }, _hoisted_8, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["radio__option", {'active': !_ctx.loading}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLoading(0)))
          }, _hoisted_11, 2)
        ])
      ]),
      _createElementVNode("h3", _hoisted_12, [
        _createTextVNode("아래 "),
        (_ctx.currTab=='predict')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "예측"))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, "추천")),
        _createTextVNode(" 버튼을 클릭하여 결과를 확인하세요.")
      ])
    ]),
    (_ctx.currTab=='predict')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["button__blue", {'no-active':_ctx.editPatient.data[0].length == 0}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editPatient.data[0].length !== 0?_ctx.tdmPredict():''))
        }, "예측", 2))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["button__blue", {'no-active':_ctx.editPatient.PT_NO==''}]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editPatient.PT_NO!==''?_ctx.tdmRecom():''))
        }, "추천", 2))
  ]))
}